import React from 'react';
import './Class.css';
import class11 from '../../Images/Class-11.png';
import {Helmet} from "react-helmet";
const Class11 = () => (
  <div className="explore-container">
    <Helmet>
                <meta charSet="utf-8" />
                <title>Vigyaan Ki Udaan - Otter Tutor</title>
                <link rel="canonical" href="http://ottertutors.com" />
            </Helmet>
    {/* Back Button */}
    <button className="back-button" onClick={() => window.history.back()}>
      ← Back
    </button>
    {/* Lakshya Card (Right Side, Above Header) */}
    <div className="lakshya-card">
      <img
        src={class11}
        loading="lazy"
        alt="Lakshya NEET 3.0"
        className="lakshya-image"
      />
      <div className="course-details">
  <p className="pricing">💳 Monthly Fees: ₹ 1599/-</p>
  <p className="pricing">💼 Fees Billed Till Exams: ₹ 7999/-</p>
  <a href="https://rzp.io/rzp/vigyaankiudaan" target="_blank" rel="noopener noreferrer">
    <button className="buy-button">Buy Now</button>
  </a>
</div>

    </div>

    {/* Lakshya Header (Full Width) */}
    <div className="lakshya-header">
      <div className="lakshya-header-content">
        <h2 className="lakshya-title">Vigyaan ki <span className='highlight'>Udaan</span>(Class-<span className='highlight'>11</span>)</h2>
        
      </div>
    </div>

 {/* Batch Details Section */}
 <div className="batch-details">
      <h3>Description</h3>
      <ul>
  <li><strong>1️⃣Focused Learning with Small Batches</strong>  
    <ul>
      <li>🌱 Only 10 students per batch for personalized attention and expert guidance.</li>
    </ul>
  </li>
  <li><strong>2️⃣Subjects to Master in Class 11</strong>  
    <ul>
      🧮 Mathematics
      🔬 Physics
      ⚗️ Chemistry
      🧬 Biology
    </ul>
  </li>
  <li><strong>3️⃣Structured & Dynamic Daily Classes</strong>  
    <ul>
      <li>🕒 Two engaging 1-hour sessions daily with passionate tutors to keep you on track!</li>
    </ul>
  </li>
  <li><strong>4️⃣24/7 Doubt-Solving Support</strong>  
    <ul>
      <li>🩵 Get round-the-clock support—we’re always here to solve your doubts and clarify concepts!</li>
    </ul>
  </li>
  <li><strong>5️⃣Live & Interactive Learning</strong>  
    <ul>
      <li>👩‍🏫 Live, engaging lessons with expert tutors to boost your confidence and understanding.</li>
    </ul>
  </li>
  <li><strong>6️⃣Learning Through Experiments</strong>  
    <ul>
      <li>🔬 Experience science concepts in action with hands-on experiments to connect theory with real life.</li>
    </ul>
  </li>
  <li><strong>7️⃣Topic-Wise Practice Sheets</strong>  
    <ul>
      <li>📝 Practice sheets designed by experts to help you master each topic with ease.</li>
    </ul>
  </li>
  <li><strong>8️⃣Regular Assessments & Quizzes</strong>  
    <ul>
      <li>🎯 Weekly tests and live quizzes ensure continuous improvement and help track your progress.</li>
    </ul>
  </li>
  <li><strong>9️⃣1-on-1 Doubt Solving</strong>  
    <ul>
      <li>💬 Personalized learning experience with one-on-one doubt solving whenever you need it.</li>
    </ul>
  </li>
  <li><strong>🔟Practical Applications</strong>  
    <ul>
      <li>🌍 Real-world connections to understand how the concepts apply in everyday life.</li>
    </ul>
  </li>
  <li><strong>1️⃣1️⃣Free Coding Classes</strong>  
    <ul>
      <li>📚 FREE Coding Course to develop technical skills that will prepare you for the future.</li>
    </ul>
  </li>
  <li><strong>1️⃣2️⃣Expert Guidance</strong>  
    <ul>
      <li>👩‍🏫 Learn from top-notch science educators with years of experience and passion for teaching.</li>
    </ul>
  </li>
  <li><strong>🌈 What Makes Us Special?</strong>  
    <ul>
      <li>🌟 Expert tutors passionate about guiding you to academic excellence.</li>
      <li>🌍 Practical, hands-on learning for better understanding and real-world connection.</li>
    </ul>
  </li>
  <li><strong>📩 Need More Info?</strong>  
    <ul>
      <li>Email us at <a href="mailto:support@ottertutors.com">support@ottertutors.com</a></li>
    </ul>
  </li>
  <br/>
  <li><strong>🚀 Join <span className='highlight1'>"Vigyaan Ki Udaan"</span> Elevate your Class 11 journey with expert tutors, interactive learning, and unwavering support!</strong>  
   
  </li>
</ul>


    </div>

    {/* FAQ Section */}
    <div className="faq-section">
      <h2>FAQs</h2>
      <p style={{ textAlign: 'center' }}>
  Here are some of the frequently asked questions:
</p>
      <div className="faq-grid">
        <div className="faq-item">
        🎯
          <div>
            <h3>Who Should Join "Vigyaan Ki Udaan"?</h3>
            <p>
            🎓 Perfect for Class 11 students who aim to excel in board exams (CBSE Board)
            </p>
          </div>
        </div>
        <div className="faq-item">
        🎯
          <div>
            <h3>Where Will the Classes Be Held?</h3>
            <p>💻 Classes are held on Zoom, and all class links are shared via our WhatsApp groups.</p>
          </div>
        </div>
        <div className="faq-item">
        🎯
          <div>
            <h3>How Can I Get Help If I Have Doubts?</h3>
            <p>💬 24/7 doubt-solving support—we are always here to assist you, no matter when you need help!
            </p>
          </div>
        </div>
        <div className="faq-item">
        🎯
          <div>
            <h3>What If I Miss a Class?
            </h3>
            <p>
            📼 No worries! Recordings of all classes will be available for you to review at any time.
            </p>
          </div>
        </div>
        <div className="faq-item">
        🎯
          <div>
            <h3>Are Tests and Quizzes Mandatory?
            </h3>
            <p>
            ✅ Yes! Weekly tests and live quizzes are designed to track your progress and keep you engaged.
            </p>
          </div>
        </div>
        <div className="faq-item">
        🎯
          <div>
            <h3>Can I get a refund after batch purchase?</h3>
            <p>
            💡 No refunds are available once the batch is purchased. We’ve invested a lot into providing you with top-notch learning resources. Please make a well-thought-out decision before purchasing!
            </p>
          </div>
        </div>
      </div>
    </div>
  </div>
);

export default Class11;
